import React, { forwardRef, useState } from "react";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import {
  Grid,
  IconButton,
  Badge,
  Menu,
  MenuItem,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { MoreVert, CheckCircle, Cancel, Add } from "@material-ui/icons";

import { Handle } from "../Item/components";
import { contruirKeysFromData } from "views/Tablero/utils/funcionesiIndexTablero";
import styles from "./Container.module.css";
import serviciosTablero from "utils/serviciosTablero";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

const useStyles = makeStyles((theme) => ({
  btnAceptar: {
    backgroundColor: "#4d90fe",
    color: "#000",
    "&:hover": {
      backgroundColor: "#357ae8",
    },
  },
  btnCancelar: {
    backgroundColor: "#4d90fe",
    color: "#000",
    "&:hover": {
      backgroundColor: "#357ae8",
    },
  },
  dialogTitle: {
    backgroundColor: "#323638",
    color: "#CCCCCC",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontFamily: "Arial",
    fontSize: "18.0pt",
    fontWeight: "400",
    textTransform: "uppercase",
  },
  dialogContent: {
    backgroundColor: "#323638",
    color: "#fff",
  },
  dialogActions: {
    backgroundColor: "#323638",
  },
  tituloEtapa: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    boxSizing: "border-box",
    minHeight: "20px",
    margin: 0,
    padding: "6px 8px 6px 12px",
    overflow: "hidden",
    borderRadius: "8px",
    boxShadow: "none",
    fontWeight: "600",
    overflowWrap: "break-word",
    fontFamily:
      "Segoe UI,Roboto,Noto Sans,Ubuntu,Droid Sans,Helvetica Neue,sans-serif",
  },
}));

export const Container = forwardRef(
  (
    {
      children,
      columns = 1,
      handleProps,
      horizontal,
      hover,
      onClick,
      label,
      placeholder,
      style,
      scrollable,
      shadow,
      unstyled,
      dataGeneral,
      dataEtapa,
      infoTablero,
      setData,
      setItems,
      handleRemoveColumn,
      setCargando,
      setMensaje,
      updateData,
      idjerarquia,
      usuario,
      permisos,
      esPrimeraEtapa,
      ...props
    },
    ref
  ) => {
    const styleLabelFormColor = {
      fontFamily:
        '"Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif',
      fontWeight: "bold",
    };
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState({ current: null });
    const [componenteTitulo, setComponenteTitulo] = useState(label);
    const [modalColor, setModalColor] = useState(false);
    const { handleSubmit, register, errors, getValues } = useForm();
    const [mAdvertencia, setMAdvertencia] = useState({
      open: false,
      data: null,
    });

    const cerrarAdvertencia = () =>
      setMAdvertencia({ open: false, data: null });

    const abrirMenu = (row) => (event) => {
      setAnchorEl({ current: event.currentTarget, row: row });
    };
    const cerrarMenu = () => setAnchorEl({ ...anchorEl, current: null });

    const guardarTitulo = () => {
      serviciosTablero.updateEtapaInfo(
        (status, mensaje, data) => {
          let indexEtapa = dataGeneral.indexOf(dataEtapa);
          let nuevaDataGeneral = dataGeneral;
          nuevaDataGeneral[indexEtapa].titulo = getValues("tituloEtapa");
          setData(nuevaDataGeneral);
          setComponenteTitulo(getValues("tituloEtapa"));
          setMensaje({ open: true, status: status, value: mensaje });
        },
        setCargando,
        { idetapa: dataEtapa.idetapa, nombre: getValues("tituloEtapa") }
      );
    };

    const guardarColor = () => {
      serviciosTablero.updateEtapaInfo(
        (status, mensaje, data) => {
          let indexEtapa = dataGeneral.indexOf(dataEtapa);
          let nuevaDataGeneral = dataGeneral;
          nuevaDataGeneral[indexEtapa].color = getValues("colorEtapaForm");
          setData(nuevaDataGeneral);
          setModalColor(false);
          setMensaje({ open: true, status: status, value: mensaje });
        },
        setCargando,
        { idetapa: dataEtapa.idetapa, color: getValues("colorEtapaForm") }
      );
    };

    const habilitarEditarTitulo = (data) => {
      setComponenteTitulo(
        <form>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <TextField
                name="tituloEtapa"
                defaultValue={dataEtapa.titulo}
                inputRef={register({
                  required: { value: true, message: "Campo requerido" },
                })}
              />
            </Grid>
            <Grid item xs={2}>
              <IconButton
                onClick={() => {
                  guardarTitulo(data);
                }}
                title="Guardar"
                style={{ color: "green" }}
              >
                <CheckCircle />
              </IconButton>
            </Grid>
            <Grid item xs={2}>
              <IconButton
                onClick={() => {
                  setComponenteTitulo(dataEtapa.titulo);
                }}
                title="Cancelar"
                style={{ color: "red" }}
              >
                <Cancel />
              </IconButton>
            </Grid>
          </Grid>
        </form>
      );
    };
    const agregarTarjeta = () => {
      serviciosTablero.crearTarjeta(
        (status, mensaje, data) => {
          let indexEtapa = dataGeneral.indexOf(dataEtapa);
          let nuevaDataGeneral = dataGeneral;
          let tarjetaTemplate = {
            ...data,
            indexTarjeta: "t" + data.idtarjeta,
          };
          nuevaDataGeneral[indexEtapa].tarjetas = [
            ...nuevaDataGeneral[indexEtapa].tarjetas,
            tarjetaTemplate,
          ];
          //Actualizar nueva data
          setData(nuevaDataGeneral);
          setItems(contruirKeysFromData(nuevaDataGeneral));
          setMensaje({ open: true, status: status, value: mensaje });
        },
        setCargando,
        { idetapa: dataEtapa.idetapa, titulo: "Sin título" }
      );
    };
    const eliminarEtapa = () => {
      if (dataEtapa?.tarjetas?.length == 0) {
        setMAdvertencia({
          open: true,
          mensajeConfirmacion: "¿Esta seguro de eliminar la etapa?",
          confirmar: () => handleRemoveColumn(dataEtapa),
        });
      } else {
        setMAdvertencia({
          open: true,
          mensajeConfirmacion:
            "Para eliminar la etapa no debe contener tarjetas.",
        });
      }
    };
    const opcionesEtapa = [
      { titulo: "Editar titulo", onClick: habilitarEditarTitulo },
      { titulo: "Asignar color", onClick: () => setModalColor(true) },
      { titulo: "Asignar Estatus", onClick: () => {} },
      { titulo: "Eliminar", onClick: eliminarEtapa },
    ];
    return (
      <div
        {...props}
        ref={ref}
        style={{
          ...style,
          "--columns": columns,
          backgroundColor: dataEtapa?.color || "#595959",
        }}
        className={classNames(
          styles.Container,
          unstyled && styles.unstyled,
          horizontal && styles.horizontal,
          hover && styles.hover,
          placeholder && styles.placeholder,
          scrollable && styles.scrollable,
          shadow && styles.shadow
        )}
        onClick={onClick}
        tabIndex={onClick ? 0 : undefined}
      >
        <PerfectScrollbar
          options={{
            wheelSpeed: 1, // Velocidad del scroll
            suppressScrollX: true, // Desactiva scroll horizontal
          }}
          style={{
            height: "100%", // Asegura que ocupe todo el contenedor
            overflow: "hidden", // Evita el scroll nativo
          }}
        >
          <Grid container spacing={1}>
            <Grid item xs={10} style={{ color: "#FFFFFF" }}>
              {typeof componenteTitulo == "string" ? (
                dataEtapa.es_general !== 1 && infoTablero?.idtipo == 1 ? (
                  <Handle
                    {...handleProps}
                    label={componenteTitulo || "Sin título"}
                  />
                ) : (
                  <Typography className={classes.tituloEtapa}>
                    {componenteTitulo || "Sin título"}
                  </Typography>
                )
              ) : (
                componenteTitulo
              )}
            </Grid>

            {infoTablero?.idtipo == 1 && dataEtapa.es_general !== 1 && (
              <Grid item xs={2}>
                <IconButton
                  aria-label="more"
                  aria-controls="long-menu"
                  aria-haspopup="true"
                  onClick={abrirMenu({})}
                >
                  <Badge badgeContent={0} color="secondary">
                    <MoreVert />
                  </Badge>
                </IconButton>
              </Grid>
            )}

            <Menu
              anchorEl={anchorEl.current}
              keepMounted
              open={Boolean(anchorEl.current)}
              onClose={cerrarMenu}
            >
              {opcionesEtapa.map((opcion, index) => (
                <MenuItem
                  key={"OpcionFila" + index}
                  onClick={() => {
                    opcion.onClick(dataEtapa);
                    cerrarMenu();
                  }}
                >
                  {opcion.titulo}
                </MenuItem>
              ))}
            </Menu>
          </Grid>

          {placeholder ? children : <ul>{children}</ul>}
          {infoTablero?.idtipo == 1 && esPrimeraEtapa && (
            <div>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Button
                    style={{ width: "100%", color: "#FFFFFF" }}
                    onClick={agregarTarjeta}
                  >
                    <Add />
                    Agregar tarjeta
                  </Button>
                </Grid>
              </Grid>
            </div>
          )}

          <Dialog onClose={() => setModalColor(false)} open={modalColor}>
            <DialogTitle>
              Asignar color a etapa - {dataEtapa?.titulo || ""}
            </DialogTitle>
            <DialogContent>
              <label for="colorEtapaForm" style={{ ...styleLabelFormColor }}>
                Selecciona un color:
              </label>
              <br></br>
              <input
                type="color"
                name="colorEtapaForm"
                defaultValue={
                  dataEtapa?.color && dataEtapa?.color !== ""
                    ? dataEtapa.color
                    : "#595959"
                }
                ref={register({
                  required: { value: true, message: "Campo requerido" },
                })}
              />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => guardarColor()}
                style={{ backgroundColor: "#33eb91", color: "#ffff" }}
              >
                Guardar
              </Button>
              <Button
                onClick={() => setModalColor(false)}
                style={{ backgroundColor: "#ffcf33", color: "#ffff" }}
              >
                Cerrar
              </Button>
            </DialogActions>
          </Dialog>
          {/* Modal de Advertencia */}
          <Dialog
            open={mAdvertencia.open}
            onClose={cerrarAdvertencia}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle className={classes.dialogTitle}>
              Advertencia
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
              <DialogContentText>
                {mAdvertencia.mensajeConfirmacion}
              </DialogContentText>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              <Button
                onClick={cerrarAdvertencia}
                className={classes.btnCancelar}
              >
                Cerrar
              </Button>
              {mAdvertencia?.confirmar && (
                <Button
                  onClick={mAdvertencia.confirmar} // Confirma y envía los datos
                  className={classes.btnAceptar}
                >
                  Confirmar
                </Button>
              )}
            </DialogActions>
          </Dialog>
        </PerfectScrollbar>
      </div>
    );
  }
);
